<template>
  <div class="poi" ref="dom" :style="getstyle(poidata)">
    <div class="line"></div>
    <div class="icon"></div>
  </div>
</template>

<script>
// import cfg from "./config.js";
export default {
  props: ["poidata"],
  methods: {
    getstyle(poidata) {
      let s = (1 - poidata.s) * 4;
      if (s > 3) s = 3;
      if (s < 0.8) s = 0.8;
      return `left:${poidata.left}px;top:${poidata.top}px;transform: translate3d(-50%, -50%, 0) scale(${s});`;
    },
  },
};
</script>

<style lang="scss" scoped>
.poi {
  position: absolute;
  width: 1px;
  height: 1px;
  z-index: 99;
}
.line {
  position: absolute;
  width: 1px;
  height: 10px;
  background: blue;
  transform: translateX(-50%);
  bottom: 0;
  z-index: 99;
}

.icon {
  position: absolute;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: blue;
  transform: translateX(-50%);
  bottom: 10px;
  z-index: 99;
  cursor: pointer;
  color: aliceblue;
}
.icon div {
  display: none;
  position: absolute;
  left: 100%;
  background: rgba(0, 0, 0, 0.5);
  font-size: 0.05rem;
  color: #4de7ff;
  z-index: 999;
  padding: 0.03rem 0.1rem;
  border: 0.02rem solid #4de7ff;
  border-radius: 0.1rem;
}
.icon:hover div {
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/poi.vue